import { render } from "./TabsOnDemand.vue?vue&type=template&id=7fb53d24"
import script from "./TabsOnDemand.vue?vue&type=script&lang=js"
export * from "./TabsOnDemand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__